export enum HomeActionsTypes {
  SHOW_NEW_PRODUCTS = "HOME_SHOW_NEW_PRODUCTS",
}
